// Vendors
import styled from 'styled-components';

const CancelDropModalDescriptionComponentStyled = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing_250};
  text-align: center;
  width: 100%;
`;
CancelDropModalDescriptionComponentStyled.displayName = 'CancelDropModalDescriptionComponentStyled';

export { CancelDropModalDescriptionComponentStyled };
